<!--
* UIID: UI-DLB-MBL-180
* UI Name: Select Code Table
* Modify Date: 2020/07/24
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display"
  >
    <!-- [S]  Popup title-->
    <template v-slot:title>
      <v-card-title class="headline white--text" primary-title>{{
        $t('lbl.mapBuilder.selectCodeTable.selectCodeTableHeader')
      }}</v-card-title>
    </template>
    <template v-slot:button-close>
      <!-- <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <!-- [E]  Popup title-->
    <!-- [S]  Data Section-->
    <v-row class="ma-0">
      <!-- [S]  left component-->
      <v-col cols="5" class="pa-0 pr-1">
        <v-card-text class="data-section pa-0 pr-8 pl-8 mr-0">
          <v-row class="ma-0">
            <!-- [S]  first table-->
            <v-col cols="12" class="pa-0">
              <v-row class="ma-0">
                <v-col class="pa-0">
                  <v-text-field
                    v-model="searchCodeGroup"
                    class="data-table-filter-text-field search-button-data-analysis-table"
                    heigth="30"
                    placeholder="Find by code group name"
                    outlined
                    hide-details
                    dense
                    solo
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 pt-2">
                  <v-data-table
                    fixed-header
                    :search="searchCodeGroup"
                    :headers="headerList.headerCodeGroup"
                    :items="codetables"
                    :items-per-page="-1"
                    :hide-default-footer="true"
                    :disable-sort="true"
                    class="map-list-table pb-0"
                  >
                    <template v-slot:body="{ items }">
                      <tbody>
                        <tr
                          tr
                          v-for="(item, index) in items"
                          @click="onClickCodeGroup(item)"
                          :key="item.ROWID"
                          :class="[
                            selectedRowGroup == item.CODE_CTG_ID ||
                            (selectedRowGroup == '' && index == 0)
                              ? 'selected_row'
                              : '',
                          ]"
                        >
                          <td>
                            <input
                              type="radio"
                              v-model="slectedCtg"
                              :value="item.CODE_CTG_ID"
                              name="matched-map"
                              @click="selectCodeDataItem(item)"
                            />
                          </td>
                          <td class="code-grp-col no-wrap">{{ item.CODE_CTG_NAME }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-col>
            <!-- [E]  first table-->
          </v-row>
        </v-card-text>
      </v-col>
      <!-- [E]  left component-->
      <!-- [S]  right component-->
      <v-col cols="7" class="pa-0 pl-1">
        <v-card-text class="data-section pa-0 pr-8 pl-8 mr-0">
          <v-row class="ma-0">
            <!-- [S]  second table-->
            <v-col cols="5" class="pa-0 pr-3">
              <v-row class="ma-0">
                <v-col class="pa-0">
                  <v-text-field
                    v-model="searchCodeName"
                    class="data-table-filter-text-field search-button-data-analysis-table"
                    heigth="30"
                    placeholder="Code Name"
                    outlined
                    hide-details
                    dense
                    solo
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 pt-2">
                  <v-data-table
                    fixed-header
                    :search="searchCodeName"
                    :headers="headerList.headerCodeName"
                    :items="codeLinkedGroup"
                    :items-per-page="-1"
                    :hide-default-footer="true"
                    :disable-sort="true"
                    class="map-list-table pb-0"
                  >
                    <template v-slot:body="{ items }">
                      <tbody>
                        <tr
                          tr
                          v-for="(item, index) in items"
                          @click="onClickCodeDataPool(item)"
                          :key="item.ROWID"
                          :class="[selectedRowLinked == item.CODE_GRP_CD ? 'selected_row' : '']"
                        >
                          <td class="code-grp-col no-wrap">{{ item.CODE_GRP_CD }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-col>
            <!-- [E]  second table-->

            <!-- [S]  third table-->
            <v-col cols="7" class="pa-0">
              <v-row class="ma-0">
                <v-col class="pa-0">
                  <v-row class="ma-0">
                    <v-col cols="6" class="pa-0 pr-1">
                      <v-text-field
                        v-model="codeDataPoolItems.data[0].SRC_CD"
                        class="data-table-filter-text-field search-button-data-analysis-table"
                        heigth="30"
                        placeholder="Source Code"
                        outlined
                        hide-details
                        dense
                        solo
                        @keyup.enter="queryCodeDataPool(selectedRowLinked)"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" class="pa-0 pl-1">
                      <v-text-field
                        v-model="codeDataPoolItems.data[0].TRG_CD"
                        class="data-table-filter-text-field search-button-data-analysis-table"
                        heigth="30"
                        placeholder="Target Code"
                        outlined
                        hide-details
                        dense
                        solo
                        @keyup.enter="queryCodeDataPool(selectedRowLinked)"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 pt-2">
                  <v-data-table
                    fixed-header
                    :headers="headerList.headerSourceTarget"
                    :items="dataPoolList"
                    :items-per-page="-1"
                    :hide-default-footer="true"
                    :disable-sort="true"
                    class="map-list-table pb-0"
                  >
                    <template v-slot:body="{ items }">
                      <tbody>
                        <tr
                          tr
                          v-for="item in items"
                          @click="onClickCodeSourceTarget(item)"
                          :key="item.ROWID"
                          :class="[selectedRowPool == item.CODE_ITM_SRC_CD ? 'selected_row' : '']"
                        >
                          <td class="code-grp-col no-wrap">{{ item.CODE_ITM_SRC_CD }}</td>
                          <td class="code-grp-col no-wrap">{{ item.CODE_ITM_TRG_CD }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-data-table>
                  <div class="d-inline-flex pa-0" style="width:100%">
                    <v-select
                      v-model="itemsPerPage"
                      :items="rowPerPage"
                      @change="queryCodeDataPool(selectedRowLinked)"
                      class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox pt-2"
                      hide-details
                      dense
                      solo
                    ></v-select>
                    <v-select
                      v-model="page"
                      :items="listPage"
                      @change="queryCodeDataPool(selectedRowLinked, false)"
                      class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox pl-2 pt-2"
                      hide-details
                      dense
                      solo
                    ></v-select>
                    <!-- <div id="page-count-custom" class="flat-table-pagination pl-2">
                      <v-pagination
                        v-model="page"
                        :length="pageCount"
                        @input="queryCodeDataPool(selectedRowLinked, false)">
                      </v-pagination>
                    </div>-->
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <!-- [E]  third table-->
          </v-row>
        </v-card-text>
      </v-col>
      <!-- [E]  right component-->
    </v-row>
    <!-- [E]  Data Section-->
    <v-divider class="ml-0 mr-0 mt-2 divder-popup" inset></v-divider>
    <v-row class="ml-0 mr-0">
      <v-col class="button-col action-col" lg="12">
        <div class="btn-form-control text-right">
          <v-btn class="btn btn-delete btn-popup" @click="removeDialog">{{
            $t('btn.common.close')
          }}</v-btn>
        </div>
      </v-col>
    </v-row>
  </dialog-drag>
</template>

<script>
/* globals Store */

import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import { mapState } from 'vuex';
import $ from 'jquery';
import IconSvg from '@/vue-caas/components/IconBase.vue';

import {
  showSuccessMessage,
  showErrorMessage,
  showProgress,
  hideProgress,
  alertSuccess,
  closeAlert,
} from '@/vue-dlb/utils/sys-util.js';

export default {
  name: 'maplist-dialog',
  props: ['id', 'title', 'options', 'eventCb', 'selectFile', 'closeDialog', 'dragStart', 'dragEnd'],
  components: {
    DialogDrag,
    IconSvg,
  },
  computed: {
    ...mapState('codetable', {
      codetables: 'codetables',
      codeLinkedGroup: 'codeLinkedGroup',
      codeDataPool: 'codeDataPool',
    }),
  },
  data() {
    return {
      page: 1,
      pageCount: 1,
      itemsPerPage: 100,
      rowPerPage: [
        { value: 100, text: 'Show 100' },
        { value: 200, text: 'Show 200' },
        { value: 500, text: 'Show 500' },
      ],
      listPage: [{ value: 1, text: 'Page 1' }],
      storeDataPool: [],
      slectedCtg: '',
      selectedRowLinked: '',
      selectedRowPool: '',
      selectedRowGroup: '',
      dataPoolList: [],
      dataList01: [],
      searchCodeGroup: '',
      searchCodeName: '',
      searchSource: '',
      searchTarget: '',
      overlay: false,
      absolute: true,
      isActive: true,
      selected_map: '',
      mapData: [],
      userRow: 'admin',
      customerSelect: false,
      srmData: '',
      // searchItems: {
      //   src : {
      //     type: '',
      //     search: ''
      //   },
      //   target : {
      //     type: '',
      //     search: ''
      //   }
      // },
      codetableItems: {
        header: ['CUST_ID', 'OWNR_CUST_ID'],
        data: [
          {
            CUST_ID: '',
            OWNR_CUST_ID: '',
          },
        ],
      },
      codeLinkedGroupItems: {
        header: ['CTG_ID'],
        data: [
          {
            CTG_ID: '',
          },
        ],
      },
      codeDataPoolItems: {
        header: ['CUST_ID', 'OWNR_CUST_ID', 'GRP_CD', 'SRC_CD', 'TRG_CD', 'R_FROM', 'R_TO', 'SORT'],
        data: [
          {
            CUST_ID: '',
            OWNR_CUST_ID: '',
            GRP_CD: '',
            SRC_CD: '',
            TRG_CD: '',
            R_FROM: 1,
            R_TO: this.itemsPerPage,
            SORT: 'DEFAULT',
          },
        ],
      },
      headerList: {
        headerCodeGroup: [
          {
            text: this.$t('tbl.mapBuilder.selectCodeTable.select'),
            value: '',
            width: '90px',
          },
          {
            text: this.$t('tbl.mapBuilder.selectCodeTable.codeGroup'),
            value: 'CODE_CTG_NAME',
          },
        ],
        headerCodeName: [
          {
            text: this.$t('tbl.mapBuilder.selectCodeTable.groupCode'),
            value: 'CODE_GRP_CD',
            width: '100px',
          },
        ],
        headerSourceTarget: [
          {
            text: this.$t('tbl.mapBuilder.selectCodeTable.sourceCode'),
            value: 'CODE_ITM_SRC_CD',
            width: '100px',
          },
          {
            text: this.$t('tbl.mapBuilder.selectCodeTable.targetCode'),
            value: 'CODE_ITM_TRG_CD',
            width: '100px',
          },
        ],
      },
    };
  },

  created() {
    this.selectedRowGroup = this.options.item.codeCtg;
    this.slectedCtg = this.options.item.codeCtg;
    this.queryCodetables();
  },

  watch: {
    // 2021.4.28 203728 SPKA-80 Issue 42 Add paging for Code Data Pool
    pageCount(newVal, oldVal) {
      if (newVal != oldVal) {
        this.listPage = [];
        for (let i = 1; i <= newVal; i++) {
          this.listPage.push({ value: i, text: 'Page ' + i });
        }
      }
    },
  },

  methods: {
    queryCodetables() {
      this.codetableItems.data[0].CUST_ID = this.$cookies.get('comp-id');
      this.codetableItems.data[0].OWNR_CUST_ID = this.$cookies.get('ownr-id');
      Store.dispatch('codetable/codetables', this.codetableItems).then(() => {
        if (this.codetables.length > 0) {
          // 203705_Map Manager_fix issues 12
          if (this.slectedCtg == '' || typeof this.slectedCtg == 'undefined') {
            this.selectedRowGroup = this.codetables[0].CODE_CTG_ID;
            this.queryCodeLinkedGroup(this.codetables[0].CODE_CTG_ID);
          } else {
            this.queryCodeLinkedGroup(this.slectedCtg);
          }
        }
      });
    },
    queryCodeLinkedGroup(item) {
      this.codeLinkedGroupItems.data[0].CTG_ID = item;
      Store.dispatch('codetable/codeLinkedGroup', this.codeLinkedGroupItems).then(() => {
        if (this.codeLinkedGroup.length > 0) {
          this.selectedRowLinked = this.codeLinkedGroup[0].CODE_GRP_CD;
          this.queryCodeDataPool(this.codeLinkedGroup[0].CODE_GRP_CD);
        } else {
          this.dataPoolList = [];
        }
      });
    },
    queryCodeDataPool(item, resetPage = true) {
      if (resetPage) this.page = 1;
      this.codeDataPoolItems.data[0].CUST_ID = this.$cookies.get('comp-id');
      this.codeDataPoolItems.data[0].OWNR_CUST_ID = this.$cookies.get('ownr-id');
      this.codeDataPoolItems.data[0].GRP_CD = item;
      // 2021.4.28 203728 SPKA-80 Issue 42 Add paging for Code Data Pool
      this.codeDataPoolItems.data[0].R_FROM = this.itemsPerPage * (this.page - 1) + 1;
      this.codeDataPoolItems.data[0].R_TO = this.itemsPerPage * this.page;
      Store.dispatch('codetable/codeDataPoolPaging', this.codeDataPoolItems).then((res) => {
        this.dataPoolList = res.codeDataPool;
        this.pageCount = Math.floor(res.totalDataPool / this.itemsPerPage) + 1;
        if (res.codeDataPool.length > 0) {
          this.selectedRowPool = res.codeDataPool[0].CODE_ITM_NO;
          this.storeDataPool = this.dataPoolList;
        }
      });
    },
    onClickCodeGroup(item) {
      this.selectedRowGroup = item.CODE_CTG_ID;
      if (item.CODE_CTG_ID != undefined && item.CODE_CTG_ID != null)
        this.queryCodeLinkedGroup(item.CODE_CTG_ID);
    },
    onClickCodeDataPool(item) {
      this.selectedRowLinked = item.CODE_GRP_CD;
      if (item.CODE_GRP_CD != undefined && item.CODE_GRP_CD != null)
        this.queryCodeDataPool(item.CODE_GRP_CD);
    },
    onClickCodeSourceTarget(item) {
      this.selectedRowPool = item.CODE_ITM_SRC_CD;
    },
    // onFilterSourceTarget(item) {
    //   this.searchItems.src.type = 'CODE_ITM_SRC_CD';
    //   this.searchItems.src.search = this.searchSource;
    //   this.searchItems.target.type = 'CODE_ITM_TRG_CD';
    //   this.searchItems.target.search = this.searchTarget;
    //   this.searchItems.source = this.storeDataPool;
    //   Store.commit('codetable/SET_CODE_FILTER', this.searchItems);
    //   this.dataPoolList = this.codeDataPool;
    // },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    selectCodeDataItem(item) {
      if (!this.options.item.readOnly) {
        this.$emit('selectCodeItem', item);
        this.removeDialog({});
      }
    },
  },
};
</script>
<style>
.mapbuilder-scanner-list .dialog-body .v-card__text.data-section {
  height: 300px;
}
.mapbuilder-scanner-list .code-grp-col {
  text-align: left !important;
}
.mapbuilder-scanner-list
  .v-text-field.data-table-filter-text-field
  .v-input__control
  .v-input__slot {
  margin-left: 0px !important;
}
.mapbuilder-scanner-list .code-table {
  padding: 10px 5px 0px 0px;
}

.theme--dark .codetable-list .v-data-table tbody tr.selected_row {
  background: #243645 !important;
}

.codetable-list input[type='radio'] {
  vertical-align: middle;
}
</style>
